export const ChallengesURLOption = "challenges"
export const ChallengePackURLOption = "sidcp"
export const StorageKeyCSRFToken = "@SLASHID/CSRF_TOKEN"
export const StorageKeyPKCECodeVerifier = "@SLASHID/PKCE_CODE_VERIFIER"
export const StorageKeyOIDCClientID = "@SLASHID/OIDC_CLIENT_ID"
export const StorageKeyOIDCRedirectUri = "@SLASHID/OIDC_REDIRECT_URI"
